import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../../enums/contentStack.js";
import { getConfigurationSettingByDeveloperKey } from "../../../../services/content/business.lib.js";
import { getFeatureFlagState } from "../../../../utils/featureFlag.js";
import { MODERN_ADD_TO_LIST_APIS_FEATURE_FLAG_DEV_KEY } from "../constants.js";
import { AddToListProviderClient } from "./AddToListContextProvider.js";
const COMPONENT_NAME = "AddToListProvider";
const AddToListProvider = async (props) => {
  const { locale, children } = props;
  const contentStackValues = await getConfigurationSettingByDeveloperKey(
    ContentType.ModuleSettings,
    "add_to_list_popup",
    locale
  );
  if (!contentStackValues) {
    throw new Error("Missing Add to List Module Settings");
  }
  let enableModernApis = false;
  try {
    const featureFlagState = await getFeatureFlagState(
      MODERN_ADD_TO_LIST_APIS_FEATURE_FLAG_DEV_KEY,
      process.env.APPNAME
    );
    enableModernApis = featureFlagState.isEnabled;
  } catch (error) {
    console.error(
      `Error fetching feature toggle: ${MODERN_ADD_TO_LIST_APIS_FEATURE_FLAG_DEV_KEY} from ConfigStack.`,
      error
    );
  }
  return /* @__PURE__ */ jsx(
    AddToListProviderClient,
    {
      contentStackValues,
      enableModernApis,
      children
    }
  );
};
AddToListProvider.displayName = COMPONENT_NAME;
export {
  AddToListProvider
};
